import {gql} from '@apollo/client'

export const GET_ALL_CANTERAS = gql`
  query quarryList($after: String, $id: Float, $offset: Int) {
    quarryList(after: $after, id: $id, offset: $offset) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          address
          created
          description
          id
          name
          phoneNumber
        }
      }
    }
  }
`
